export const SDK_VERSION = '7.48.0';
